declare namespace $ {

	type $mol_select__value_shm_hitalama_settings_agent_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['current'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_settings_agent_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Current'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Menu_links'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_major__title_shm_hitalama_settings_agent_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_settings_agent_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $shm_hitalama_settings_agent_string__input_name_shm_hitalama_settings_agent_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['name_input_name'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['input_name'] >
	>
	type $shm_hitalama_settings_agent_string__value_shm_hitalama_settings_agent_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_name'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Name'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__value_shm_hitalama_settings_agent_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_backend'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_settings_agent_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['backend_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Backend'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__value_shm_hitalama_settings_agent_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_connection'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_settings_agent_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['connection_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Connection'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_text__text_shm_hitalama_settings_agent_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['connection_hint'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $shm_hitalama_settings_agent_string__input_name_shm_hitalama_settings_agent_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['url_input_name'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['input_name'] >
	>
	type $shm_hitalama_settings_agent_string__value_shm_hitalama_settings_agent_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_url'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['url_label'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Url'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_settings_agent_password__input_name_shm_hitalama_settings_agent_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['token_input_name'] >
		,
		ReturnType< $shm_hitalama_settings_agent_password['input_name'] >
	>
	type $shm_hitalama_settings_agent_password__value_shm_hitalama_settings_agent_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_token'] >
		,
		ReturnType< $shm_hitalama_settings_agent_password['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Token'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_settings_agent_string__input_name_shm_hitalama_settings_agent_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['mcp_url_input_name'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['input_name'] >
	>
	type $shm_hitalama_settings_agent_string__hint_shm_hitalama_settings_agent_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['mcp_url_hint'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['hint'] >
	>
	type $shm_hitalama_settings_agent_string__value_shm_hitalama_settings_agent_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_mcp_url'] >
		,
		ReturnType< $shm_hitalama_settings_agent_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['mcp_url_label'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Mcp_url'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_hitalama_settings_agent_password__input_name_shm_hitalama_settings_agent_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['mcp_token_input_name'] >
		,
		ReturnType< $shm_hitalama_settings_agent_password['input_name'] >
	>
	type $shm_hitalama_settings_agent_password__hint_shm_hitalama_settings_agent_36 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_settings_agent_password['hint'] >
	>
	type $shm_hitalama_settings_agent_password__value_shm_hitalama_settings_agent_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_mcp_token'] >
		,
		ReturnType< $shm_hitalama_settings_agent_password['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_agent_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_agent_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['Mcp_token'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_minor__title_shm_hitalama_settings_agent_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_settings_agent_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['check_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_settings_agent_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['check'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_shm_hitalama_settings_agent_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['check_status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__attr_shm_hitalama_settings_agent_44 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $shm_hitalama_settings_agent['check_status_hidden'] >,
			'status': ReturnType< $shm_hitalama_settings_agent['check_status_kind'] >,
		})  & ReturnType< $mol_paragraph['attr'] >
		,
		ReturnType< $mol_paragraph['attr'] >
	>
	type $mol_view__sub_shm_hitalama_settings_agent_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_settings_agent_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_field_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_settings_agent_47 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['remove'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_page__title_shm_hitalama_settings_agent_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_agent['config_name'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_hitalama_settings_agent_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_hitalama_settings_agent_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_hitalama_settings_agent extends $mol_book2_catalog {
		current( next?: string ): string
		config_dictionary( ): Record<string, any>
		Current( ): $mol_select
		Current_label( ): $mol_labeler
		Configs_label( ): $mol_labeler
		add( next?: any ): any
		Add( ): $mol_button_major
		name_input_name( id: any): string
		config_name( id: any, next?: string ): string
		Name( id: any): $shm_hitalama_settings_agent_string
		Name_label( id: any): $mol_labeler
		config_backend( id: any, next?: string ): string
		backend_dictionary( ): Record<string, any>
		Backend( id: any): $mol_select
		Backend_label( id: any): $mol_labeler
		config_connection( id: any, next?: string ): string
		connection_dictionary( ): Record<string, any>
		Connection( id: any): $mol_select
		Connection_label( id: any): $mol_labeler
		connection_hint( id: any): string
		Connection_hint( id: any): $mol_text
		url_label( id: any): string
		url_input_name( id: any): string
		config_url( id: any, next?: string ): string
		Url( id: any): $shm_hitalama_settings_agent_string
		Url_label( id: any): $mol_labeler
		token_input_name( id: any): string
		config_token( id: any, next?: string ): string
		Token( id: any): $shm_hitalama_settings_agent_password
		Token_label( id: any): $mol_labeler
		mcp_url_label( id: any): string
		mcp_url_input_name( id: any): string
		mcp_url_hint( id: any): string
		config_mcp_url( id: any, next?: string ): string
		Mcp_url( id: any): $shm_hitalama_settings_agent_string
		Mcp_url_label( id: any): $mol_labeler
		mcp_token_input_name( id: any): string
		config_mcp_token( id: any, next?: string ): string
		Mcp_token( id: any): $shm_hitalama_settings_agent_password
		Mcp_token_label( id: any): $mol_labeler
		check_enabled( id: any): boolean
		check( id: any, next?: any ): any
		Check( id: any): $mol_button_minor
		check_status( id: any): string
		check_status_hidden( id: any): boolean
		check_status_kind( id: any): string
		Check_status( id: any): $mol_paragraph
		Check_row( id: any): $mol_view
		config_field_rows( id: any): readonly(any)[]
		Config_fields( id: any): $mol_list
		remove( id: any, next?: any ): any
		Remove( id: any): $shm_confirm_delete
		remove_visible( id: any): readonly(any)[]
		param( ): string
		menu_title( ): string
		menu_body( ): readonly(any)[]
		Config( id: any): $mol_page
	}
	
}

//# sourceMappingURL=agent.view.tree.d.ts.map